<template>
  <div v-if="mailing">
    <div class="hpanel no-margins">

      <template v-if="displayMailingText">
        <div class="panel-heading">
          Mailing texts
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Experts added through the platform
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject</label>
                  <div v-html="mailing.template.subject"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-md-6">

            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Manually added experts
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject </label>
                  <div v-html="mailing.template.subject_manual"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body_manual"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12" v-if="mailing.template.subject_organisation">
            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Mailing Template for contacted companies
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject</label>
                  <div v-html="mailing.template.subject_organisation"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body_organisation"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </div>

    <template v-if="displayMailingStats">
      <div class="hpanel">

        <div class="panel-heading">
          Mailing Stats
        </div>

        <div class="panel-body" >

          <div class="row">
            <div class="col-xs-12">
              <table class="table text-center no-margins">
                <thead>
                <th class="text-center"><i class="fa fa-send"></i> Sent</th>
                <th class="text-center"><i class="fa fa-envelope-open"> Opened</i></th>
                <th class="text-center"><i class="fa fa-hand-o-down"></i> Clicked</th>
                <th class="text-center"><i class="fa fa-undo"></i> Bounced</th>
                <th class="text-center"><i class="fa fa-exclamation-circle"></i> Spam</th>
                </thead>
                <tbody>
                <tr>
                  <td>{{mailingEvent('sent')}}</td>
                  <td>{{mailingEvent('open')}}</td>
                  <td>{{mailingEvent('click')}}</td>
                  <td>{{mailingEvent('bounce')}}</td>
                  <td>{{mailingEvent('spam')}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </template>

    <template v-if="displayContactedExperts">
      <div class="hpanel">

        <div class="panel-heading">
          Contacted Experts
        </div>

        <div class="panel-body" >
          <experts-contacted :experts="mailing.authors" :eventsExperts="mailing.events_authors"/>
        </div>

      </div>
    </template>
  </div>
</template>

<script>

import ExpertsContacted from './ExpertsContacted'
export default {
  components: {ExpertsContacted},
  name: 'MailingReport',
  props: {
    mailingId: {
      require: true,
      type: Number
    },
    displayMailingText: {
      default: false
    },
    displayMailingStats: {
      default: false
    },
    displayContactedExperts: {
      default: false
    }
  },
  data () {
    return {
      mailing: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/mailing/' + this.mailingId + '?relations={template,mailing_events}')
        .then((response) => {
          this.mailing = response.data

          this.$emit('resourcesLoaded', this.mailingId)
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    mailingEvent: function (eventName) {
      let event = this.mailing.mailing_events.find((item) => {
        return item.event === eventName
      })

      return typeof event === 'undefined' ? 0 : event.nb_event
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mailing/Report.vue